import { array, func } from 'prop-types';
import { parse, stringify } from 'query-string';
import React, { Component, Fragment } from 'react';
import SVG from 'react-inlinesvg';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Button } from 'reactstrap';
import { startSetOffersSettings, startSetSourcesList } from '../../../actions/app';
import { setRedirectToPaymentsData } from '../../../actions/finances';
import {
  resetOffersCatalogFilter,
  setOffersCatalogFilter,
  setOfferToMy,
  startSetOffers,
  startSetOffersTabs,
} from '../../../actions/offers';
import { startCopyStream, startSetStreamSettings } from '../../../actions/streams.js';
import {
  startRefuseOfferAccess,
  startRequestOfferAccess,
  setJustRegisteredHasOffer,
  startSetManager,
} from '../../../actions/webmaster';
// import OffersList from '../../../components/Offers/OffersList';
import { OffersList } from '../../../components/Offers/index';
import OffersListLoader from '../../../components/Offers/OffersListLoader';
import { STATIC_PATH } from '../../../config';
import { appConstants } from '../../../constants/app';
import { offersConstants } from '../../../constants/offers';
import { FMessage, iFMessage } from '../../../hoc/IntlComponents';
import WithAlert from '../../../hoc/WithAlert';
import { offers as offersRequests, req } from '../../../services/ApiService.js';
import { debounce } from '../../../utils/utils';
import { prepareCopyFlow } from '../../flows/FlowsPage/FlowsPage.js';
import { ThemedOffersPage } from '../index';

const defaultState = {
  page: 0,
  limit: 50,
};

class OffersPage extends Component {
  static propTypes = {
    offers: array.isRequired,
    tabs: array.isRequired,
    setOfferToMy: func.isRequired,
    startSetOffersTabs: func.isRequired,
    startSetOffersSettings: func.isRequired,
    resetOffersCatalogFilter: func.isRequired,
    setOffersCatalogFilter: func.isRequired,
    startRequestOfferAccess: func.isRequired,
    startSetOffers: func.isRequired,
    sources: array.isRequired,
  };

  static defaultProps = {
    offers: [],
    tabs: [],
    sources: [],
  };

  constructor(props) {
    super(props);

    const {
      page = defaultState.page,
      limit = defaultState.limit,
      tab,
      sortOrder = '',
      sortBy = '',
      ...rest
    } = this.getParsedParams();

    this.updateLocation({
      ...rest,
      page,
      limit,
      tab: props.match.params.tab,
    });

    this.state = {
      ...defaultState,
      page: page !== undefined ? +page : defaultState.page,
      limit: limit !== undefined ? limit : defaultState.limit,
      loading: false,
      isСopied: null,
      tab: '',
      offers: [],
      limits: [50, 100, 200, 'All'],
      hasMore: true,
      sortOrder,
      sortBy,
      search: false,
      found: 0,
      error: {},
      offersCount: 0,
      offerRequestModalOpen: false,
      offerRequestSuccessModalOpen: false,
      offerHasFlowsModalOpen: false,
      mounted: false,
      selectedOffer: null,
      selectedOfferFlows: [],
      allowedOfferInfo: null,
      showBanner: false,
      showSpOffersTour: false,
    };

    this.cardHeaderRef = null;
  }

  updateLocation = (params, withoutSearch) => {
    const parsedParams = parse(window.location.search);
    const queryParams = { ...parsedParams, ...params };
    let withoutSearchParams = {};
    if (withoutSearch) {
      const { search, ...without } = queryParams;
      withoutSearchParams = { ...without };
    }
    history.replaceState(
      {},
      null,
      `${window.location.pathname}?${stringify(
        !withoutSearch ? queryParams : withoutSearchParams,
      )}`,
    );
  };

  componentDidMount() {
    const { page, limit } = this.state;

    this.findFilters();
    this.setState(() => ({ loading: true }));

    if (!this.props.webmaster.manager) {
      this.props.startSetManager();
    }
    this.props.startSetStreamSettings();
    this.props.startSetOffersSettings();
    this.props.startSetSourcesList();
    this.props
      .startSetOffersTabs()
      .then(() => this.getTab())
      .then(() => {
        let queryParams;
        queryParams = {
          ...this.getParsedParams(),
          tab: this.state.tab,
          limit,
          page,
        };
        this.updateLocation(queryParams);
        return this.props.startSetOffers(queryParams);
      })
      .then(() =>
        this.setState(
          () => ({
            loading: false,
            offers: this.props.offers,
            mounted: true,
          }),
          () => {
            if (!localStorage.getItem('sp_offers_tour_shown'))
              this.setState({ showSpOffersTour: true });
            this.getPage();
          },
        ),
      );

    if (!localStorage.getItem('hide_offers_banner_004')) this.setState({ showBanner: true });
  }

  getOffers = (params) => {
    this.setState(() => ({ loading: true }));
    this.props.startSetOffers(params).then(() => {
      this.setState(() => ({
        offers: this.props.offers,
        loading: false,
      }));
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.getOffersCount(nextProps.offers);
    this.handleOfferFilters({
      prevFilters: this.props.catalogFilters,
      nextFilters: nextProps.catalogFilters,
    });
  }

  handleOfferFilters = ({ prevFilters, nextFilters }) => {
    const { limit, tab, mounted, sortBy, sortOrder } = this.state;
    const prevFiltersLength = this.countFiltersLength(prevFilters);
    const nextFiltersLength = this.countFiltersLength(nextFilters);
    const difference = prevFiltersLength - nextFiltersLength;
    if (difference && mounted) {
      const { page, ...parsedParams } = this.getParsedParams();
      if (parsedParams.search) {
        this.updateLocation({
          tab,
          limit,
          search: parsedParams.search,
          page: 0,
          sortBy,
          sortOrder,
        });
        this.getOffers({
          ...parsedParams,
          tab,
          limit,
          search: parsedParams.search,
          page: 0,
          sortBy,
          sortOrder,
        });
      } else {
        this.updateLocation({ tab, limit, page: 0, sortBy, sortOrder });
        this.getOffers({ ...parsedParams, tab, limit, page: 0, sortBy, sortOrder });
      }
      this.getPage();
    }
  };

  countFiltersLength = (filters) => {
    const currentFilters = Object.keys(filters);
    if (!currentFilters.length) {
      return 0;
    } else {
      return currentFilters.reduce((acc, curr) => {
        return acc + filters[curr].length;
      }, 0);
    }
  };

  componentWillUnmount() {
    req.cancel(offersConstants.SET_OFFERS_TABS_REQUEST);
    req.cancel(offersConstants.SET_OFFER_FILTERS_REQUEST);
    req.cancel(offersConstants.SET_OFFERS_LIST_REQUEST);
    req.cancel(appConstants.SET_OFFERS_SETTINGS_REQUEST);
    this.props.resetOffersCatalogFilter();
  }

  setPage = (number = 1) => {
    const { offers = [] } = this.state;
    let page = number - 1;

    if (!isNaN(page) && page > 0) {
      page = page >= offers.length ? offers.length - 1 : page;
      this.setState(() => ({ page }));
    } else {
      this.setState(() => ({ page: 0 }));
    }
  };

  getPage = () => {
    const { page = 1 } = this.getParsedParams();
    this.setPage(+page);
  };

  findFilters = () => {
    const { limit, page, tab, search, ...filters } = this.getParsedParams();
    if (Object.keys(filters).length > 0) {
      this.props.setOffersCatalogFilter(this.prepareFilters(filters));
    }
  };

  prepareFilters = (items = {}) =>
    Object.keys(items).reduce((filters, key) => {
      if (items[key]) {
        const filter = { [key]: this.normalizeValues(items[key], key) };

        return { ...filters, ...filter };
      }

      return filters;
    }, {});

  normalizeValues = (values = '', param) => {
    const normalized = Array.isArray(values) ? values : values.split(',').filter(String);

    return normalized.map((val) => {
      if (!isNaN(val)) {
        return parseInt(val, 10);
      }

      val = ('' + val).trim();

      if (param === 'countries') {
        return val.toUpperCase();
      }

      return val;
    });
  };

  getTab = () => {
    let { tab } = this.props.match.params;
    const currentTab =
      this.props.tabs.find((t) => t.prefix === tab) ||
      this.props.tabs.find((t) => t.prefix === 'all');
    if (currentTab) {
      tab = currentTab.prefix;
      this.setState(() => ({ tab }));
      this.updateLocation({ tab });
    }
  };

  getOffersCount = (offers) => {
    const { tab } = this.state;
    if (tab && offers) {
      this.setState(() => ({
        offersCount: offers.length,
      }));
    }
  };

  renderTabs = () => {
    const { tabs, intl, language } = this.props;
    // не показывать категорию 'Бурж COD' если выбран английский язык
    return !tabs
      ? []
      : tabs
          .filter(({ id }) => (language === 'ru' ? true : id !== 4))
          .map(({ prefix, id, count }) => {
            const { tab, page, sortOrder, sortBy, ...extraParams } = this.getParsedParams();
            return (
              <NavLink
                id={`${prefix}-${id}`}
                to={{
                  pathname: `/offers/${prefix}`,
                  search: `?${stringify({ ...extraParams, tab: prefix })}`,
                }}
                key={prefix}
                className={`nav-link nav-link--offer-tab nav-link--${prefix}`}
                isActive={() => this.state.tab === prefix}
                title={iFMessage({ intl, id: `offers.tabs.title.${id}` })}
                exact
              >
                {/* <span className="isvg">
                  <SVG
                    src={`${STATIC_PATH}/img/offers/tabs/${prefix}.svg?1`}
                    width={16}
                    cacheRequests
                  />
                </span> */}
                <span className="offers-tabs-title">
                  <FMessage id={`offers.tabs.title.${id}`} />
                </span>
                &nbsp;
                {count !== undefined ? (
                  <ins className="offers-count">({count})</ins>
                ) : (
                  <span>(0)</span>
                )}
              </NavLink>
            );
          });
  };

  changePage = (page) => {
    const { limit } = this.state;

    let parsedParams;
    parsedParams = {
      ...this.getParsedParams(),
      limit,
      page,
    };

    this.getOffers(parsedParams);
    this.setState(() => ({ page }));
  };

  getParsedParams = () => parse(window.location.search);

  changeLimit = (limit) => {
    const page = 0;
    this.setState(() => ({
      page,
      limit,
    }));
    this.updateLocation({ limit, page });
    this.getOffers({ ...this.getParsedParams(), limit, page });
  };

  searchOffers = (search = '') => {
    this.setState({ loading: true });
    this.updateLocation({ search, page: 0 });
    const { page, ...parsedParams } = this.getParsedParams();
    this.props
      .startSetOffers({ ...parsedParams, search })
      .then(({ type }) => {
        if (type === offersConstants.CANCEL_REQUEUS) {
          // Если во время запроса успеть изменить поле поиска => отменяется старый запрос - начинается новый => сохраняем loading: true
          this.setState({ laoding: true });
        } else {
          this.setState(() => ({
            loading: false,
            offers: this.props.offers,
            page: 0,
          }));
        }
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message: error } = response.data.error;

          this.props.showAlert({
            alertType: 'danger',
            dismissable: false,
            closeInSeconds: 3,
            message: error.message,
          });
        } else {
          this.props.showAlert({
            alertType: 'danger',
            dismissable: false,
            closeInSeconds: 3,
            message: 'Server error',
          });
        }

        this.setState(() => ({ loading: false }));
      });
  };

  handleSearch = debounce((query = '') => {
    if (query.length < 3) {
      const { search, page, ...params } = this.getParsedParams();
      this.updateLocation(params, true);
      this.getOffers(params);
      this.setState(() => ({ page: 0 }));
    } else if (query.length >= 3) {
      this.searchOffers(query);
    }
  }, 500);

  resetFilters = () => {
    const { tab, limit, page } = this.state;
    history.replaceState(
      {},
      null,
      `${window.location.pathname}?${stringify({ tab, limit, page })}`,
    );
    this.handleSearch('');
    this.props.resetOffersCatalogFilter();
    this.resetScrollerPage();
  };

  resetScrollerPage = () => {
    if (this.scroll) {
      this.scroll.pageLoaded = 0;
    }
  };

  handleRequestOfferAccess = (offerId, offerTitle, is_my) => {
    const { intl, history, showAlert, justRegistered } = this.props;
    if (is_my) return history.push(`/tools/flows/create?offer=${offerId}`);
    this.props
      .startRequestOfferAccess(offerId)
      .then(() => this.props.setOfferToMy(offerId))
      .then(() => {
        if (justRegistered.is && !justRegistered.hasOffer) {
          this.props.setJustRegisteredHasOffer();
        }
        this.props.showAlert({
          alertType: 'success',
          dismissable: false,
          closeInSeconds: 3,
          message: intl.formatMessage(
            {
              id: 'offer.allowed-access.message',
              defaultMessage: `Access to «{offer}» is provided`,
            },
            { offer: offerTitle },
          ),
        });
        offersRequests.getOfferInfo(offerId).then((data) => {
          this.setState(
            () => ({ allowedOfferInfo: data.items[0] }),
            () => this.offerRequestSuccessModalOpen(),
          );
        });
        this.setState(() => ({
          offers: this.props.offers,
        }));
      })
      .catch(({ response }) => {
        if (response && response.data) {
          const { message: error } = response.data.error;

          if (error.type && error.type === 'api.account.offer_request_ticket') {
            history.push(`/tickets/create?offer=${offerId}&theme=highLevelAccessRequest`);
          } else {
            showAlert({
              alertType: 'danger',
              message: error.message,
              redirectComponent: this.getErrorComponent(error, { offerId }),
              redirectPath: this.getErrorLink(error.type, { offerId }),
            });
          }
        }
      });
  };

  handleRefuseOfferAccess = (id) =>
    this.props.startRefuseOfferAccess(id).then(() => this.getOffers({ ...this.getParsedParams() }));

  getErrorComponent = ({ message, type }, { offerId }) => {
    const { setRedirectToPaymentsData } = this.props;
    switch (type) {
      case 'api.purses.empty':
        return (
          <Fragment>
            <span>
              <FMessage id="offers.error.no-wmz" />
            </span>
            <span
              role="button"
              className="link"
              onClick={() =>
                setRedirectToPaymentsData({
                  type: 1,
                  pathname: '/profile/payment-data',
                })
              }
            >
              <FMessage id="offers.error.no-wmz.link.title" />
            </span>
          </Fragment>
        );
      default:
        return null;
    }
  };

  getErrorLink = (type, { offerId }) => {
    switch (type) {
      case 'api.purses.empty':
        return '/profile/payment-data';
      case 'api.profile.phone.empty':
      case 'api.profile.phone.not_approved':
        return '/profile/edit';
      case 'api.account.offer_request_ticket':
        return `/tickets/create?offer=${offerId}&theme=highLevelAccessRequest`;
      default:
        return false;
    }
  };

  renderRequestOfferButton = () => {
    return (
      <Button color="primary" size="sm" onClick={this.offerRequestModalOpen}>
        <span className="offer-request-button-desk">
          <FormattedMessage
            id="offer.buttons.offer-request"
            defaultMessage="Can't find needed product?"
          />
        </span>
        <span className="offer-request-button-mob" />
      </Button>
    );
  };

  offerRequestModalOpen = () => {
    this.setState(() => ({
      offerRequestModalOpen: true,
    }));
  };

  offerRequestModalToggle = () => {
    this.setState((prevState) => ({
      offerRequestModalOpen: !prevState.offerRequestModalOpen,
    }));
  };

  offerRequestSuccessModalOpen = () => {
    this.setState(() => ({
      offerRequestSuccessModalOpen: true,
    }));
  };

  offerRequestSuccessModalToggle = () => {
    this.setState((prevState) => ({
      offerRequestSuccessModalOpen: !prevState.offerRequestSuccessModalOpen,
    }));
  };

  offerHasFlowsModalToggle = () => {
    this.setState((prevState) => ({
      offerHasFlowsModalOpen: !prevState.offerHasFlowsModalOpen,
    }));
  };

  offerHasFlowsModalOpen = () => {
    this.setState(() => ({
      offerHasFlowsModalOpen: true,
    }));
  };

  handleFlowCreate = (offerId) => {
    const { history } = this.props;
    this.setState(() => ({
      loading: true,
    }));
    offersRequests.getOffer(offerId).then(({ items }) => {
      this.setState(() => ({
        loading: false,
      }));
      if (items) {
        const [offer] = items;
        const { flows } = offer;

        if (flows && flows.length) {
          this.setState(
            () => ({
              selectedOffer: offerId,
              selectedOfferFlows: flows,
            }),
            () => {
              this.offerHasFlowsModalOpen();
            },
          );
        } else {
          history.push(`/tools/flows/create?offer=${offerId}`);
        }
      }
    });
  };

  getPageCount = () => {
    const { limit, tab } = this.state;
    const { tabs } = this.props;

    const currentTab = tabs.find(({ prefix }) => prefix === tab);
    if (currentTab) {
      if (currentTab.count !== undefined) {
        if (currentTab.count >= 0) {
          return Math.ceil(currentTab.count / limit);
        }
      }
    }
    return 0;
  };

  handleSort = (by, order) => {
    this.setState(
      () => {
        return {
          sortBy: by,
          sortOrder: order,
          page: 0,
        };
      },
      () => {
        const { sortBy, sortOrder, limit } = this.state;
        this.updateLocation({ limit, page: 0, sortBy, sortOrder });
        this.getOffers({ ...this.getParsedParams(), limit, sortBy, sortOrder, page: 0 });
      },
    );
  };

  hasMoreOffers = (ammounts) => {
    const { offers, tab } = this.state;
    return ammounts[tab] > offers.length;
  };

  loadMoreOffers = (page) => {
    const { limit, tab } = this.state;
    this.setState(() => ({ loading: true }));
    const { ...parsedParams } = this.getParsedParams();
    this.props
      .startSetOffers({ ...parsedParams, tab, limit, search: parsedParams.search, page })
      .then(({ ammounts }) => {
        this.setState((prevState) => ({
          offers: [...prevState.offers, ...this.props.offers],
          loading: false,
          hasMore: this.hasMoreOffers(ammounts),
        }));
      });
  };

  handleUnavailableOfferClick = (e) => {
    const { intl } = this.props;
    const { slug } = this.props.webmaster.manager;

    e.preventDefault();

    this.props.showAlert({
      alertType: 'danger',
      message: slug
        ? intl.formatMessage(
            {
              id: 'offers.alert.category-locked-manager',
              defaultMessage: '',
            },
            { slug },
          )
        : intl.formatMessage({
            id: 'offers.alert.category-locked-support',
            defaultMessage: '',
          }),
      dismissable: true,
      closeInSeconds: 5,
    });
  };

  renderOffersList = () => {
    const { offers, search, found, /*mounted,*/ sortOrder, sortBy, tab, loading } = this.state;
    const { currencies, offers: offersFromProps } = this.props;
    // if (!mounted) {
    //   return <OffersListLoader offersCount={25} isSearching={false} />;
    // }
    if (search && found === 0) {
      return <div className="card-empty">Продукты не найдены</div>;
    }
    if (offers.length > 0 || offersFromProps.length > 0) {
      return (
        <OffersList
          tab={tab}
          removeOffer={this.handleRefuseOfferAccess}
          offers={offers.length > 0 ? offers : offersFromProps}
          onRequestOfferAccess={this.handleRequestOfferAccess}
          onFlowCreate={this.handleFlowCreate}
          sortOrder={sortOrder}
          sortBy={sortBy}
          handleSort={this.handleSort}
          currencies={currencies}
          onUnavailableOfferClick={this.handleUnavailableOfferClick}
        />
      );
    }
    return loading ? (
      <OffersListLoader offersCount={25} isSearching={false} />
    ) : (
      <div className="card-empty">Продукты не найдены</div>
    );
  };

  getActiveLimit = (limit) => (isNaN(limit) ? limit : +limit);

  copyFlow = (flowId, offerId) => {
    const { startCopyStream, intl, base, startSetStreamSettings } = this.props;
    const newTitle = `${intl.formatMessage({
      id: 'flow.form.title.placeholder',
      defaultMessage: 'Flow',
    })} ${base.nextFlowIndex}`;
    this.setState({ isСopied: flowId }, () => {
      startCopyStream(flowId, newTitle, prepareCopyFlow)
        .then(() => offersRequests.getOffer(offerId))
        .then(({ items }) => this.setState({ selectedOfferFlows: items[0].flows, isСopied: null }))
        .then(() => startSetStreamSettings());
    });
  };

  handleCloseBannerClick = () => {
    this.setState({ showBanner: false });
    localStorage.setItem('hide_offers_banner_004', true);
  };

  handleCloseSpTourClick = () => {
    this.setState({ showSpOffersTour: false });
    localStorage.setItem('sp_offers_tour_shown', true);
  };

  render() {
    const pageCount = this.getPageCount();
    const { showAlert, sources, intl, tabs, countries, offerSettings } = this.props;
    const data = { ...this.state, tabs, countries, offerSettings };

    return (
      <ThemedOffersPage
        data={data}
        getParsedParams={this.getParsedParams}
        pageCount={pageCount}
        showAlert={showAlert}
        sources={sources}
        intl={intl}
        renderTabs={this.renderTabs}
        renderRequestOfferButton={this.renderRequestOfferButton}
        handleSearch={this.handleSearch}
        resetFilters={this.resetFilters}
        changePage={this.changePage}
        getActiveLimit={this.getActiveLimit}
        changeLimit={this.changeLimit}
        renderOffersList={this.renderOffersList}
        offerRequestModalToggle={this.offerRequestModalToggle}
        offerHasFlowsModalToggle={this.offerHasFlowsModalToggle}
        offerRequestSuccessModalToggle={this.offerRequestSuccessModalToggle}
        copyFlow={this.copyFlow}
        onRequestOfferAccess={this.handleRequestOfferAccess}
        loadMoreOffers={this.loadMoreOffers}
        onCloseBannerClick={this.handleCloseBannerClick}
        onCloseSpTourClick={this.handleCloseSpTourClick}
      />
    );

    // return (
    //   <Layout formattedTitle="pages.offers.title">
    //     <Layout.Col>
    //       <Card className="offers-list card-loading-silent" loading={loading}>
    //         <Card.HeaderNav
    //           navLinks={this.renderTabs()}
    //           innerRef={el => (this.cardHeaderRef = el)}
    //           controls={this.renderRequestOfferButton()}
    //           navClasses="col-lg-8 col-4"
    //           loading={loading}
    //         />

    //         <Card.Body>
    //           <OffersListFilters onSearch={this.handleSearch} />
    //           {mounted && (
    //             <Row className="controls-row">
    //               <Col xl="8" lg="7" md="8">
    //                 {pageCount > 1 && (
    //                   <Pagination
    //                     affectUrl
    //                     pageCount={pageCount}
    //                     activePage={page + 1}
    //                     onPageChange={this.changePage}
    //                     scrollToAfterPageChanged={{
    //                       ref: this.cardHeaderRef,
    //                     }}
    //                   />
    //                 )}
    //               </Col>

    //               <Col xl="4" lg="5" md="4">
    //                 <LimitsList
    //                   activeLimit={this.getActiveLimit(limit)}
    //                   limits={limits}
    //                   onLimitChange={this.changeLimit}
    //                 />
    //               </Col>
    //             </Row>
    //           )}
    //         </Card.Body>

    //         <Card.Body className="no-padding">
    //           <Row>
    //             <Col>{this.renderOffersList()}</Col>
    //           </Row>
    //         </Card.Body>

    //         {mounted && (
    //           <Card.Footer>
    //             <Row className="controls-row">
    //               <Col xl="8" lg="7" md="8">
    //                 {pageCount > 1 && (
    //                   <Pagination
    //                     affectUrl
    //                     pageCount={pageCount}
    //                     activePage={page + 1}
    //                     onPageChange={this.changePage}
    //                     scrollToAfterPageChanged={{
    //                       ref: this.cardHeaderRef,
    //                     }}
    //                   />
    //                 )}
    //               </Col>

    //               <Col xl="4" lg="5" md="4">
    //                 <LimitsList
    //                   activeLimit={this.getActiveLimit(limit)}
    //                   limits={limits}
    //                   onLimitChange={this.changeLimit}
    //                   className="no-margin"
    //                 />
    //               </Col>
    //             </Row>
    //           </Card.Footer>
    //         )}
    //       </Card>
    //     </Layout.Col>
    //     <OfferRequestModal
    //       open={offerRequestModalOpen}
    //       toggle={this.offerRequestModalToggle}
    //       showAlert={showAlert}
    //     />
    //     <OfferHasFlowsModal
    //       toggle={this.offerHasFlowsModalToggle}
    //       open={offerHasFlowsModalOpen}
    //       offerId={selectedOffer}
    //       flows={selectedOfferFlows}
    //     />
    //     <OfferRequestSuccessModal
    //       open={offerRequestSuccessModalOpen}
    //       toggle={this.offerRequestSuccessModalToggle}
    //       offer={allowedOfferInfo}
    //       sources={sources}
    //       intl={intl}
    //     />
    //   </Layout>
    // );
  }
}

const mapStateToProps = (state) => ({
  tabs: state.offers.tabs,
  offers: state.offers.catalog,
  catalogFilters: state.offers.catalogFilters,
  sources: state.app.globalSettings.sources,
  currencies: state.app.globalSettings.currencies,
  base: state.streams.settings.base,
  countries: state.offers.filters.countries,
  offerSettings: state.app.settings.offer,
  justRegistered: state.webmaster.profile.justRegistered,
  language: state.webmaster.profile.language,
  webmaster: state.webmaster,
});

const mapDispatchToProps = (dispatch) => ({
  setOfferToMy: (id) => dispatch(setOfferToMy(id)),
  startSetOffersTabs: () => dispatch(startSetOffersTabs()),
  startSetOffersSettings: () => dispatch(startSetOffersSettings()),
  resetOffersCatalogFilter: () => dispatch(resetOffersCatalogFilter()),
  setOffersCatalogFilter: (checked) => dispatch(setOffersCatalogFilter(checked)),
  startRequestOfferAccess: (offerId) => dispatch(startRequestOfferAccess(offerId)),
  startRefuseOfferAccess: (offerId) => dispatch(startRefuseOfferAccess(offerId)),
  startSetOffers: (params) => dispatch(startSetOffers(params)),
  startSetSourcesList: () => dispatch(startSetSourcesList()),
  setRedirectToPaymentsData: (data) => dispatch(setRedirectToPaymentsData(data)),
  startCopyStream: (streamId, title, callback) =>
    dispatch(startCopyStream(streamId, title, callback)),
  startSetStreamSettings: () => dispatch(startSetStreamSettings()),
  setJustRegisteredHasOffer: () => dispatch(setJustRegisteredHasOffer()),
  startSetManager: () => dispatch(startSetManager()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WithAlert(injectIntl(OffersPage)));
